
export enum MenuType {
    // Drinks
    DrinkTab = 'DrinkTab',

    // Foods
    Menu = 'Menu',
}
